import { useEffect, useState } from "react";
import { Checkbox } from "../../../components/Checkbox";
import { Hairline } from "../../../components/Hairline";
import { Label } from "../../../components/Label";
import styles from "../../../../styles/beneficios/steps/BenefitTypeSelectStep.module.scss";
import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const BenefitEnvironment = ({ benefit, brands, onChange }) => {
  const [brandsSelected, setBrands] = useState([]);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (benefit?.brands_valid)
      setBrands(benefit.brands_valid.map((item) => item?.id || item));
  }, [benefit]);

  const addBrand = (brandId) => {
    if (brandsSelected.includes(brandId)) {
      onChange({
        ...benefit,
        brands_valid: brandsSelected.filter((item) => item !== brandId),
      });

      return;
    }

    onChange({
      ...benefit,
      brands_valid: [...brandsSelected, brandId],
    });
  };

  return (
    <>
      <div className="d-flex align-center justify-between">
        <Label
          text="Em que marcas o benefício poderá ser utilizado?"
          className="mb-0"
        />
        <div className="d-flex align-center">
          <Checkbox
            value={true}
            checked={brandsSelected.length === brands.length}
            readOnly
          />
          <div className={styles.collapsible}>
            <div
              className={styles.chevron}
              onClick={() => setCollapsed(!collapsed)}
            >
              <i className="fas fa-chevron-down" />
            </div>

            <div
              className={css({
                collapsed: true,
                in: collapsed,
                out: !collapsed,
              })}
            >
              <ul className={styles.options}>
                <li
                  onClick={() => {
                    onChange({
                      ...benefit,
                      brands_valid: brands
                        .filter((item) => item.id)
                        .map((item) => item.id),
                    });
                    setCollapsed(false);
                  }}
                >
                  Selecionar tudo
                </li>
                <li
                  onClick={() => {
                    onChange({
                      ...benefit,
                      brands_valid: [],
                    });
                    setCollapsed(false);
                  }}
                >
                  Desmarcar tudo
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Hairline className="mt-15 mb-15" />
      {(brands || []).map((item) => {
        return (
          <Checkbox
            key={item.id}
            family="place"
            className="mt-10"
            value={true}
            checked={brandsSelected.includes(item.id)}
            onChange={() => addBrand(item.id)}
          >
            {item.name}
          </Checkbox>
        );
      })}
    </>
  );
};
